import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class CountryComparisonFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled:boolean) {
        super(Features.CountryComparison, "MultiJurisdictionCms.Dto.Features.CountryComparisonFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.CountryComparisonFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}